export default __webpack_public_path__ + "static/media/edit.46f0f58e.svg";